import { createFieldRenderer } from "../utils/columnRenderers";

const SPLIT_WIDTHS = {
  generationDate: 205,
  statusDescription: 68,
  ignition: 60,
  levelEvent: 82,
  speed: 58,
};

const GRID_ONLY_WIDTHS = {
  generationDate: 170,
  location: 420,
  statusDescription: 78,
  ignition: 72,
  levelEvent: 220,
  speed: 72,
};

export const useGridColumns = ({
  columns,
  fields,
  layoutMode,
  vehicleId,
  onDateClick,
}) => {
  const renderField = createFieldRenderer({
    vehicleId,
    layoutMode,
    onDateClick,
  });

  const buildColumnEntries = () => {
    const includeLocation = layoutMode === "grid-only";
    const entries = [];
    const seen = new Set();

    columns.forEach((column, index) => {
      const field = fields[index];
      if (!field || seen.has(field)) return;
      if (!includeLocation && field === "location") return;
      seen.add(field);
      entries.push({ column, field });
    });

    if (includeLocation && !seen.has("location")) {
      entries.push({ column: "Endereço", field: "location" });
    }

    return entries;
  };

  const entries = buildColumnEntries();
  const effectiveColumns = entries.map((e) => e.column);
  const effectiveFields = entries.map((e) => e.field);

  const getColumnWidth = (field) => {
    if (layoutMode === "split") return SPLIT_WIDTHS[field] ?? null;
    return GRID_ONLY_WIDTHS[field] ?? null;
  };

  const getColumnProps = (field, index) => {
    const baseProps = {
      locale: "pt-BR",
      key: field,
      field,
      headerText: effectiveColumns[index],
      width: getColumnWidth(field),
      textAlign: "Left",
      editType: "dropdownedit",
      template: renderField(field),
    };

    if (field === "generationDate") {
      return {
        ...baseProps,
        type: "dateTime",
        format: { type: "dateTime", format: "dd/MM/yyyy HH:mm:ss" },
        allowFiltering: false,
        allowSorting: true,
        valueAccessor: (f, data) => {
          if (!data[f] || data[f] === "0001-01-01T00:00:00") return null;
          return new Date(data[f]);
        },
      };
    }

    return baseProps;
  };

  return { effectiveFields, effectiveColumns, getColumnProps };
};
